/* eslint-disable consistent-return */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import AppButton from '../../shared/components/app-button/AppButton';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import {
  checkValidEmailAddress,
  ONLY_DATE_MONTH_FORMAT,
} from '../../shared/constants/Constants';
import FlightEmailCard from '../one-way/FlightEmailCard';
import { formatDate, getNewDate } from '../../shared/helper-utils/appUtils';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import { useAppContext } from '../../saas/AppConfigWrapper';
import { getValueFromAppConfig } from '../../shared/helper-utils/localStorage';

function EmailContent({ selectedFlights, searchRequest, onSend }) {
  const { appConfig } = useAppContext();
  const PREF_CLASS_DICT = {
    Y: 'Economy',
    W: 'Premium Economy',
    C: 'Business',
    F: 'First Class',
  };
  const [showInput, setShowInput] = useState(true);
  const [senderEmail, setSenderEmail] = useState('');
  const [validationError, setValidationError] = useState(false);
  const [showBreakup, setShowBreakup] = useState(true);
  const [markUpToBeAdded, setMarkupToBeAdded] = useState('');

  const handleSendEmail = () => {
    setShowInput(false);
    if (senderEmail === '' || checkValidEmailAddress(senderEmail)) {
      setValidationError(true);
      setShowInput(true);
      return false;
    }

    setTimeout(() => {
      const content = document.getElementById('emialContent').innerHTML;
      onSend(senderEmail, content);
    }, 500);
  };
  const getOnwardDate = (index) => {
    const newDatesArray = [];
    const datesArray = searchRequest.onwarddate.split(':');
    datesArray.forEach((date) => {
      const newdate = `${date.substring(0, 4)}-${date.substring(
        4,
        6,
      )}-${date.substring(6, 8)}`;
      newDatesArray.push(newdate);
    });
    return newDatesArray[index];
  };

  return (
    <div>
      <div className="fs-14 px-4">
        <div className="d-flex align-items-center gap-3 mb-1">
          <AppRadioInput
            id="true"
            name="showBrakup"
            labelText="With Fare"
            value=""
            onChange={() => setShowBreakup(true)}
            checked={showBreakup}
          />
          <AppRadioInput
            id="false"
            name="showBrakup"
            labelText="Without Fare"
            value=""
            onChange={() => setShowBreakup(false)}
            checked={!showBreakup}
          />
        </div>
        <Row className=" my-3">
          <Col lg={8} md={8} sm={12} xs={12}>
            <AppTextInput
              name="email"
              label="Email Address "
              placeholderText=""
              value={senderEmail}
              required
              onChange={(e) => setSenderEmail(e.target.value)}
              errorText={validationError && 'Enter Email Address'}
            />
            {checkValidEmailAddress(senderEmail) &&
              validationError &&
              senderEmail !== '' && (
                <small className="app-error-text">Enter Valid Email</small>
              )}
          </Col>
          {getValueFromAppConfig('ISCORPORATECLIENT') !== 'true' &&
            showBreakup && (
              <Col lg={4} md={4} sm={12} xs={12}>
                <AppNumberInput
                  name="markUpToBeAdded"
                  label="Markup"
                  value={markUpToBeAdded}
                  onChange={(d) => setMarkupToBeAdded(d)}
                />
              </Col>
            )}
        </Row>
      </div>
      <div className="d-flex justify-content-center align-items-center">
        <div className="overflow-auto " style={{ height: '300px' }}>
          <div id="emialContent">
            <div
              style={{
                width: '750px',
                color: '#000',
                padding: '1rem',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              <div
                className="show-no-border-in-mobile overflow-hidden"
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                }}
              >
                <div
                  style={{
                    borderTopLeftRadius: '8px',
                    borderTopRightRadius: '8px',
                    color: '#fff',
                    backgroundColor: appConfig?.clientPrimaryColor,
                    fontSize: '14px',
                  }}
                >
                  <div
                    style={{
                      borderTopLeftRadius: '8px',
                      borderTopRightRadius: '16px',
                      padding: '16px',
                      fontSize: '12px',
                      borderBottom: '1px solid #ccc',
                    }}
                    className="d-none"
                  >
                    <table style={{ width: '100%' }}>
                      <tbody>
                        <tr>
                          <td>
                            <div style={{ fontSize: '12px' }}>Journeys: </div>
                            {searchRequest.origin.split(':').map((d, index) => (
                              <div
                                key={d}
                                style={{ fontWeight: '600', fontSize: '14px' }}
                              >
                                {`${d} - ${
                                  searchRequest.destination.split(':')[index]
                                } | ${formatDate(
                                  getNewDate(getOnwardDate(index)),
                                  ONLY_DATE_MONTH_FORMAT,
                                )}`}
                              </div>
                            ))}
                          </td>
                          <td>
                            <table style={{ width: '100%' }}>
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      textAlign: 'end',
                                      fontSize: '12px',
                                    }}
                                  >
                                    Traveler Class :{' '}
                                    <span
                                      style={{
                                        fontWeight: '600',
                                        fontSize: '14px',
                                      }}
                                    >
                                      {PREF_CLASS_DICT[searchRequest.prefclass]}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ textAlign: 'end' }}>
                                    Passenger(s):{' '}
                                    <span
                                      style={{
                                        fontWeight: '600',
                                        fontSize: '14px',
                                      }}
                                    >
                                      {parseInt(searchRequest.numadults, 10)}{' '}
                                      Adult
                                      {parseInt(searchRequest.numchildren, 10) >
                                        0 &&
                                        ` ${parseInt(
                                          searchRequest.numchildren,
                                          10,
                                        )} Child`}
                                      {parseInt(searchRequest.numinfants, 10) >
                                        0 &&
                                        ` ${parseInt(
                                          searchRequest.numinfants,
                                          10,
                                        )} Infant`}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                {Object.keys(selectedFlights).map((sec, secIndex) => (
                  <React.Fragment key={sec}>
                    <div
                      style={{
                        backgroundColor: '#fc790e',
                        color: '#fff',
                        fontSize: '14px',
                        fontWeight: '500',
                        padding: '5px 10px',
                      }}
                    >
                      {`${
                        searchRequest.originlocations
                          .split(':')
                          [secIndex].split(',')[0]
                      } - ${
                        searchRequest.destinationlocations
                          .split(':')
                          [secIndex].split(',')[0]
                      } | ${formatDate(
                        getNewDate(getOnwardDate(secIndex)),
                        ONLY_DATE_MONTH_FORMAT,
                      )}`}
                    </div>
                    {selectedFlights[sec].map((selectedFlight, index) => (
                      <FlightEmailCard
                        key={selectedFlight.fare.nextraflightkey}
                        flight={selectedFlight.flight}
                        isLast={index === selectedFlights.length - 1}
                        showHideFare={showBreakup}
                        fare={selectedFlight.fare}
                        searchRequest={searchRequest}
                        markUpToBeAdded={markUpToBeAdded}
                        index={index}
                        isOnward
                        showInput={showInput}
                        onFareUpdate={() => {}}
                      />
                    ))}
                  </React.Fragment>
                ))}
                <div
                  style={{
                    backgroundColor: '#333333',
                    borderTop: '1px solid #ccc',
                    color: '#fff',
                    padding: '10px',
                    fontSize: '12px',
                    borderBottomLeftRadius: '8px',
                    borderBottomRightRadius: '8px',
                  }}
                  className="d-none"
                >
                  <span style={{ fontSize: '14px', marginBottom: '10px' }}>
                    Terms & Conditions:
                  </span>
                  <ul>
                    <li>
                      All Travel timings are as per the local time in 24hrs
                      format
                    </li>
                    <li>
                      Check passenger name and Travel Itinerary details
                      carefully
                    </li>
                    <li>
                      Names provided should be with Valid Government Approved
                      Photo ID/ Passport
                    </li>
                    <li>
                      Automated Ticketing time limit provided as per airline
                    </li>
                    <li>
                      Ensure Sufficient Funds are available for confirmation of
                      services
                    </li>
                    <li>
                      Fares and Taxes are subject to availability at the time of
                      issuance
                    </li>
                    <li>
                      We are not liable if any increase occurs due to ROE
                      fluctuation and taxes
                    </li>
                    <li>
                      Check all Visa requirement for Destination and Transit
                      country with the respective airline and embassy
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end my-2">
        <AppButton
          variant="primary"
          onClick={handleSendEmail}
          btnText="Send Email"
        />
      </div>
    </div>
  );
}

EmailContent.propTypes = {
  selectedFlights: PropTypes.array.isRequired,
  searchRequest: PropTypes.object.isRequired,
  onSend: PropTypes.func.isRequired,
};

export default EmailContent;
